import { useSelector, useDispatch } from "react-redux";
import SettingRoles from "pages/Settings/Roles";

export default function Roles() {
  const dispatch = useDispatch();
  return (
    <>
      <SettingRoles enabledSection={['admin']} />
    </>
  );
}
